import { useContext } from 'react'

import { AppContext } from 'Services/Context'

export default function useAppContext() {
  return useContext(AppContext)
}
